import { ArrowRight } from "lucide-react";
import { CHECKOUT_URL, TRUST_ITEMS } from "./data";

export const CtaButton = ({ children, testId, size = "lg", className = "" }) => (
  <a
    data-testid={testId}
    href={CHECKOUT_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`group relative inline-flex items-center justify-center gap-3 overflow-hidden rounded-full bg-gradient-to-r from-amber-400 to-amber-500 font-display font-bold text-slate-950 shadow-[0_0_44px_rgba(245,158,11,0.32)] transition-transform duration-300 hover:scale-[1.03] active:scale-95 ${
      size === "lg" ? "px-8 py-4 text-base sm:text-lg" : "px-5 py-2.5 text-sm"
    } ${className}`}
  >
    <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/45 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
    <span className="relative">{children}</span>
    <ArrowRight className="relative h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
  </a>
);

export const TrustRow = ({ className = "" }) => (
  <div
    className={`flex flex-wrap items-center gap-x-6 gap-y-2 font-tech text-[11px] uppercase tracking-[0.2em] text-slate-400 ${className}`}
  >
    {TRUST_ITEMS.map((t) => (
      <span key={t} className="flex items-center gap-2">
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
        {t}
      </span>
    ))}
  </div>
);
